import React, { useState, useEffect } from "react";
import { makeStyles, Box, Button, Container, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import Toolbar from "./Toolbar";
import {
  apiEndpoints,
  apiGetRequest,
  apiDeleteRequest,
} from "src/utils/api/api";
import { addCreatedAndUpdatedFields } from "src/utils/utils";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  }
}));

const RowButtons = (row) => {

  return (
    <Box>
      <Tooltip title="Edytuj">
        <IconButton
          aria-label="edytuj"
          component={RouterLink}
          to={`/profile/edytujprofil/${row.id}`}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

const Profiles = ({ enableGlobalLoader, disableGlobalLoader }) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [dialogOpen, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  useEffect(() => {
    enableGlobalLoader();
    apiGetRequest(apiEndpoints.getProfiles.path, true)
      .then((data) => {
        disableGlobalLoader();
        setRows(
          addCreatedAndUpdatedFields(
            data,
            "createdBy",
            "createdAt",
            "updatedBy",
            "updatedAt",
            ", "
          )
        );
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      fieldName: "name",
      sortable: true,
      main: true,
      label: "Nazwa",
    },
    {
      id: "created",
      fieldName: "createdBy",
      fieldName2: "createdAt",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kto i kiedy utworzył",
    },
    {
      id: "updated",
      fieldName: "updatedBy",
      fieldName2: "updatedAt",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kto i kiedy zmodyfikował",
    },
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      component: RowButtons,
    },
  ];

  const onSelectedRowIdsChanged = (viewSelectedRowIds) => {
    setSelectedRowIds(viewSelectedRowIds);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    enableGlobalLoader();
    setOpen(false);
    apiDeleteRequest(apiEndpoints.deleteProfiles.path, selectedRowIds, true)
      .then((data) => {
        disableGlobalLoader();
        setReloadCounter(reloadCounter + 1);
      })
      .catch((error) => {
        disableGlobalLoader();
        navigate("/profile");
      });
  };

  return (
    <Page className={classes.root} title="Profile">
      <KmPageTitle>
        Profile
      </KmPageTitle>
      <Container maxWidth={false}>
        <Toolbar dialogHandler={handleClickOpen} />
        <Box mt={3}>
          <KmFilteredTable
            headCells={headCells}
            rows={rows}
            onSelectedRowIdsChange={onSelectedRowIdsChanged}
          />
          <Dialog
            fullScreen={fullScreen}
            open={dialogOpen}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">
              {"Usuwanie profili"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Czy na na pewno chcesz usunąć zaznaczone elementy?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleClose} color="primary">
                Nie
              </Button>
              <Button onClick={handleDelete} color="primary" autoFocus>
                Tak
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(Profiles);
